import { render, staticRenderFns } from "./drawer-excel-add.vue?vue&type=template&id=0ff4010c"
import script from "./drawer-excel-add.vue?vue&type=script&setup=true&lang=js"
export * from "./drawer-excel-add.vue?vue&type=script&setup=true&lang=js"
import style0 from "./drawer-excel-add.vue?vue&type=style&index=0&id=0ff4010c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports